import React from 'react';

import { ArrowRight, CreditCard } from 'lucide-react';

import { demoLink, registerLink } from 'common/routeComponents/landing/core/constants';
import { P } from 'common/ui/Text';
import ButtonLink from 'common/uiV3/Button/ButtonLink';
import nbspLastSpace from 'common/util/nbspLastSpace';

import 'css/components/www/LandingV3/_LandingHero.scss';

type TextPretitleProps = {
  children: React.ReactNode;
};

const TextPretitle = ({ children }: TextPretitleProps) => {
  return <p className="LandingHero__pretitle">{children}</p>;
};

type Copy = {
  title: string;
  subtitle: string;
  demoButton?: string;
  registerButton?: string;
  cost?: string;
};

export type Props = {
  copy: Copy;
  registerLinkOverride?: string;
  demoLinkOverride?: string;
  pretitle?: React.ReactNode;
};

const LandingHero = ({
  copy: { title, subtitle, demoButton, registerButton, cost },
  registerLinkOverride = registerLink,
  demoLinkOverride = demoLink,
  pretitle = null,
}: Props) => {
  return (
    <section className="LandingHero">
      {pretitle}
      <h1 className="LandingHero__title">{title}</h1>
      <p className="LandingHero__subtitle">{nbspLastSpace(subtitle)}</p>
      {(registerButton || demoButton) && (
        <div className="LandingHero__ctas">
          {demoButton && (
            <ButtonLink to={demoLinkOverride} size="xlarge" responsive variant="outlined">
              {demoButton}
            </ButtonLink>
          )}
          {registerButton && (
            <ButtonLink to={registerLinkOverride} responsive size="xlarge">
              {registerButton}
              <ArrowRight aria-hidden />
            </ButtonLink>
          )}
        </div>
      )}
      {cost && (
        <P variant="bodyLg" className="LandingHero__cost">
          <CreditCard aria-hidden size={18} strokeWidth={1.5} />
          {cost}
        </P>
      )}
    </section>
  );
};

LandingHero.TextPretitle = TextPretitle;

export default LandingHero;
